import React from 'react';
import { cn } from '../cn';
import { Typography } from '../Typography/Typography';

type HelperTextProps = {
  /**
   * Sets the styles for the helper text status.
   */
  status?: 'neutral' | 'success' | 'error',
  /**
   * String to be used as helper text.
   */
  children: React.ReactNode,
}

export default function TextfieldHelperText({ status = 'neutral', children }: HelperTextProps): JSX.Element {
  return (
    <Typography tag='p' className={cn([
      'pt-1',
      'text-xs leading-[22px] min-h-[22px]',
      status === 'neutral' && [
        'text-text-lightest',
      ],
      status === 'success' && [
        'text-success',
      ],
      status === 'error' && [
        'text-error',
      ],
    ])}>{children}</Typography>
  );
}
